const SIZE_CLASSES = new Set(['xs', 'sm', 'md', 'lg']);
const VARIANT_CLASSES = new Set(['compact']);

export default function GlowGhostIcon({
  size = 'md',
  variant = 'default',
  className = '',
  ...props
}) {
  const classes = [
    'ui-glowghost-icon',
    SIZE_CLASSES.has(size) ? `ui-glowghost-icon--${size}` : null,
    VARIANT_CLASSES.has(variant) ? `ui-glowghost-icon--${variant}` : null,
    className,
  ].filter(Boolean).join(' ');

  return (
    <span
      aria-hidden="true"
      className={classes}
      data-brand-icon="glowghost"
      {...props}
    />
  );
}
